(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-finder')) {
    customElements.define('collection-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.details = this.querySelector('details');
        this.input = this.querySelector('input');
        this.list = this.querySelector('[data-results]');
        this.status = this.querySelector('[data-status]');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.details.addEventListener('toggle', () => {
          if (this.details.open) {
            if (!this.ready && !this.loading) this.loadCollections();
            else if (this.ready) this.input.focus();
          }
        }, { signal });
        this.input.addEventListener('input', () => this.filter(), { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.details.open = false;
            this.querySelector('summary').focus();
          }
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            const links = [...this.list.querySelectorAll('li:not([hidden]) a')];
            if (!links.length) return;
            event.preventDefault();
            const index = links.indexOf(document.activeElement);
            const next = event.key === 'ArrowDown' ? (index + 1) % links.length : (index < 0 ? links.length - 1 : (index - 1 + links.length) % links.length);
            links[next].focus();
          }
          if (event.key === 'Enter' && event.target === this.input) {
            const first = this.list.querySelector('li:not([hidden]) a');
            if (this.ready && first) { event.preventDefault(); first.click(); }
          }
        }, { signal });
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.details.open = false;
        }, { signal });
      }
      disconnectedCallback() {
        this.controller.abort();
        this.initialized = false;
      }
      async loadCollections() {
        this.loading = true;
        this.status.textContent = this.dataset.loading;
        this.list.setAttribute('aria-busy', 'true');
        const items = new Map();
        const visited = new Set();
        const url = new URL(this.dataset.url, location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('page', '1');
        let next = url;
        try {
          while (next) {
            if (visited.has(next.href)) throw new Error('Repeated pagination');
            visited.add(next.href);
            const response = await fetch(next, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Collection request failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const root = doc.querySelector('collection-finder');
            if (!root) throw new Error('Missing collection list');
            root.querySelectorAll('[data-results] a').forEach((link) => {
              const target = new URL(link.getAttribute('href'), location.origin);
              if (target.origin === location.origin) items.set(target.pathname, { title: link.textContent.trim(), url: target.pathname });
            });
            const more = root.querySelector('[data-next]');
            if (more) {
              const page = new URL(more.getAttribute('href'), location.origin);
              if (page.origin !== location.origin) throw new Error('Invalid pagination');
              page.searchParams.set('section_id', this.dataset.sectionId);
              if (preview) page.searchParams.set('preview_theme_id', preview);
              next = page;
            } else next = null;
          }
          const collator = new Intl.Collator(document.documentElement.lang || 'es', { sensitivity: 'base' });
          const fragment = document.createDocumentFragment();
          [...items.values()].sort((a, b) => collator.compare(a.title, b.title)).forEach((item) => {
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.textContent = item.title;
            link.href = item.url;
            li.dataset.search = this.normalize(item.title);
            li.append(link);
            fragment.append(li);
          });
          this.list.replaceChildren(fragment);
          this.querySelector('[data-next]')?.remove();
          this.querySelector('[data-search]').hidden = false;
          this.ready = true;
          this.filter();
          if (this.details.open) this.input.focus();
        } catch (error) {
          if (error.name !== 'AbortError') this.status.textContent = this.dataset.error;
        } finally {
          this.loading = false;
          this.list.removeAttribute('aria-busy');
        }
      }
      normalize(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      }
      filter() {
        const query = this.normalize(this.input.value);
        let matches = 0;
        this.list.querySelectorAll('li').forEach((item) => {
          item.hidden = !item.dataset.search.includes(query);
          if (!item.hidden) matches++;
        });
        this.status.textContent = matches ? '' : this.dataset.empty;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
